import { StandardResponse } from '@allocab/allocab-commons-shared-types';

export type APIResponseDataType = 'item' | 'list' | undefined;

// Responses
export type APIResponse<T> = StandardResponse<T>;

// Errors
export type APIError = {
  type: 'api';
  message: string;
  errorMessage?: string;
};

export const isAPIError = (error: unknown): error is APIError => {
  return (error as APIError).type === 'api';
};
